module.exports = __webpack_public_path__ + "img/chain_banner_lian.a5c60ada.png";